import { createPortal } from 'react-dom';
export var PortalContainer = function PortalContainer(_ref) {
  var children = _ref.children,
    _ref$element = _ref.element,
    element = _ref$element === void 0 ? document.body : _ref$element;
  return element ? /*#__PURE__*/createPortal(children, element) : null;
};